import { Button, MenuItem, styled } from "@mui/material";
import {
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import {
  StyledGridFooterContainer,
  StyledPageRowCount,
  StyledPageSizeSelect,
  StyledPageSizeSelectAndCountBox,
  StyledPagination,
} from "../styles";
import React from "react";

const NoPaginationFooterSC = styled("div")({
  display: "flex",
  flex: 1,
  justifyContent: "flex-end",
  alignItems: "center",
});

export const NoPaginationFooter = ({
  handleShowAll,
  totalCount,
}: {
  handleShowAll: () => void;
  totalCount?: number;
}) => {
  const apiRef = useGridApiContext();
  const totalRows = gridRowCountSelector(apiRef);

  return (
    <StyledGridFooterContainer>
      <NoPaginationFooterSC>
        {(totalCount ?? totalRows) > 7 && (
          <Button onClick={handleShowAll} disableRipple>{`Show all (${totalCount ?? totalRows})`}</Button>
        )}
      </NoPaginationFooterSC>
    </StyledGridFooterContainer>
  );
};

export const FooterWithPagination = ({
  rowsPerPageOptions,
  totalCount,
}: {
  rowsPerPageOptions: number[];
  totalCount?: number;
}) => {
  const apiRef = useGridApiContext();
  const totalRows = gridRowCountSelector(apiRef);
  const pageSize = gridPageSizeSelector(apiRef);
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const totalRowsCount = totalCount ?? totalRows;

  const firstRowIndex = (page + 1) * pageSize - pageSize;
  const lastRowIndex = (page + 1) * pageSize - 1 > totalRowsCount ? totalRowsCount - 1 : (page + 1) * pageSize - 1;

  const handleChangeRowsPerPage = (option: number) => {
    apiRef?.current?.setPageSize(option);
  };

  const pageRowCount = `${totalRowsCount === 0 ? 0 : firstRowIndex + 1}
         - ${lastRowIndex + 1} of ${totalRowsCount}`;

  return (
    <StyledGridFooterContainer>
      <StyledPagination
        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
        shape="rounded"
      />
      <StyledPageSizeSelectAndCountBox>
        <StyledPageSizeSelect
          value={Number(pageSize ?? 0)}
          onChange={(e) => handleChangeRowsPerPage(Number(e.target.value))}
        >
          {(rowsPerPageOptions ?? [])?.map((option) => {
            return (
              <MenuItem onClick={() => handleChangeRowsPerPage(option)} key={option} value={option}>
                {option}
              </MenuItem>
            );
          })}
        </StyledPageSizeSelect>
        <StyledPageRowCount>{pageRowCount}</StyledPageRowCount>
      </StyledPageSizeSelectAndCountBox>
    </StyledGridFooterContainer>
  );
};
